module["exports"] = [
  "Hr.",
  "Fr.",
  "Dr.",
  "Prof. Dr."
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/de/name/prefix.js
// module id = 369
// module chunks = 0